import { StyleSheet, ViewStyle, TextStyle } from "react-native";
import { colors, fontSizes } from "@/app/constants/styles";

type ComboModalStyles = {
  backdrop: ViewStyle;
  container: ViewStyle;
  scrollContent: ViewStyle;
  header: ViewStyle;
  title: TextStyle;
  sectionHeader: ViewStyle;
  sectionName: TextStyle;
  sectionCounter: TextStyle;
  sectionDivider: ViewStyle;
  itemRow: ViewStyle;
  itemName: TextStyle;
  stepperRow: ViewStyle;
  stepperQty: TextStyle;
  radioOuter: ViewStyle;
  radioOuterSelected: ViewStyle;
  radioInner: ViewStyle;
  footer: ViewStyle;
  removeButtonContainer: ViewStyle;
  removeItemButton: ViewStyle;
  removeItemButtonText: TextStyle;
  addToOrderButton: ViewStyle;
  addToOrderButtonText: TextStyle;
};

export const comboModalStyles = StyleSheet.create<ComboModalStyles>({
  backdrop: {
    flex: 1,
    backgroundColor: colors.blackAlpha(0.5),
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    width: "55%",
    maxHeight: "85%",
    backgroundColor: colors.cedar,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: colors.cedar30,
    overflow: "hidden",
  },
  scrollContent: {
    paddingHorizontal: 28,
    paddingTop: 28,
    paddingBottom: 12,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },
  title: {
    fontSize: fontSizes.x20,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
    flex: 1,
  },
  sectionHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 16,
    marginBottom: 12,
  },
  sectionName: {
    fontSize: fontSizes.x14,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
  },
  sectionCounter: {
    fontSize: fontSizes.x12,
    color: colors.whiteAlpha(0.8),
  },
  sectionDivider: {
    height: 1,
    backgroundColor: colors.cedar30,
    marginBottom: 12,
  },
  itemRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 16,
  },
  itemName: {
    fontSize: fontSizes.x14,
    color: colors.white,
    marginLeft: 14,
    flex: 1,
  },
  stepperRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  stepperQty: {
    fontSize: fontSizes.x16,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
    width: 36,
    textAlign: "center",
  },
  radioOuter: {
    width: 36,
    height: 36,
    borderRadius: 18,
    borderWidth: 3,
    borderColor: colors.whiteAlpha(0.5),
    alignItems: "center",
    justifyContent: "center",
  },
  radioOuterSelected: {
    width: 36,
    height: 36,
    borderRadius: 18,
    borderWidth: 3,
    borderColor: colors.white,
    alignItems: "center",
    justifyContent: "center",
  },
  radioInner: {
    width: 18,
    height: 18,
    borderRadius: 9,
    backgroundColor: colors.white,
  },
  footer: {
    flexDirection: "row",
    alignItems: "center",
    padding: 16,
    borderTopWidth: 1,
    borderTopColor: colors.cedar30,
    backgroundColor: colors.cedar,
  },
  removeButtonContainer: {
    flex: 1,
    marginLeft: 16,
  },
  removeItemButton: {
    height: 44,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: colors.albaikRed,
    backgroundColor: colors.cedar,
    alignItems: "center",
    justifyContent: "center",
  },
  removeItemButtonText: {
    fontSize: fontSizes.x14,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
  },
  addToOrderButton: {
    flex: 1,
    marginLeft: 16,
    height: 56,
    borderRadius: 8,
    backgroundColor: colors.albaikBrightRed,
    alignItems: "center",
    justifyContent: "center",
  },
  addToOrderButtonText: {
    fontSize: fontSizes.x14,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.white,
  },
});
